import { Box, Flex } from '@chakra-ui/react';
import Dialog from 'components/Dialog';
import Loader from 'components/Loader';
import { addHours, getTime } from 'date-fns';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
    fetchDetailed,
    selectDetailed,
    selectDetailedIsLoading,
    selectDetailedTimeframes,
    selectSelectedUser,
} from 'store/slices/agent';
import { ACTIVITIES } from 'types';
import { filterDataByKeys, getFilters } from '../DetailedStatistics';
import DetailedRow from './DetailedRow';
import PopupTitle from './PopupTitle';
import Summary from './Summary';
import Timeline from './Timeline';
import { formatDateTime } from './helpers';
import ActivityIndicator from 'components/ActivityIndicator';
import Label from 'components/Label';
import { selectCallouts } from 'store/slices/companySetting';

const TIMEZONE = 3;

const DetailedPopup = ({
    isOpen,
    setIsOpen,
    time,
    filtersKeys,
}: {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    time: any;
    filtersKeys: ACTIVITIES[];
}) => {
    const dispatch = useAppDispatch();
    const callouts = useAppSelector(selectCallouts);
    const { computed } = useAppSelector(selectDetailed);
    const timeframes = useAppSelector(selectDetailedTimeframes);
    const loading = useAppSelector(selectDetailedIsLoading);
    const user = useAppSelector(selectSelectedUser);

    const { parsedDate, parsedTime } = time;

    const date = formatDateTime(parsedDate, parsedTime);
    const start = getTime(addHours(date, TIMEZONE)) as unknown as Date;
    const end = getTime(addHours(date, 1 + TIMEZONE)) as unknown as Date;

    const summary = filterDataByKeys(computed, filtersKeys);
    const detailed = filterDataByKeys(timeframes, filtersKeys, true);
    const filters = getFilters(filtersKeys);

    useEffect(() => {
        if (isOpen && user?.value && start && end) {
            dispatch(
                fetchDetailed({
                    start,
                    end,
                    agentId: user?.value,
                }),
            );
        }
    }, [isOpen, user?.value]);

    return (
        <Dialog
            title={<PopupTitle time={time} />}
            forceIsOpen={isOpen}
            setOpen={setIsOpen}
            withoutCancel
            withoutSubmit
            size="6xl"
        >
            {loading ? (
                <Loader />
            ) : (
                <Box mb="24px">
                    <Flex borderRadius="8px" borderColor="gray.200" borderWidth="1px">
                        <Summary data={summary} />
                        <Flex flexDirection="column" width="100%" position="relative" padding="24px 0" gap="16px">
                            <Timeline date={date} />
                            {detailed.map(item => (
                                <DetailedRow key={item.name} type={item.name} data={item.value} />
                            ))}
                        </Flex>
                    </Flex>
                    <Flex gap="16px" paddingTop="16px" justifyContent="center" flexWrap="wrap">
                        {filters.map(item => (
                            <Label text={callouts[item]} type={item} key={item} />
                        ))}
                    </Flex>
                </Box>
            )}
        </Dialog>
    );
};

export default DetailedPopup;
